export default "__VITE_ASSET__Ci0w9GNW__"